import React from 'react';
import {connectDynamic} from '../../dynamicComponent';
import {Form, Grid, Header} from 'semantic-ui-react';
import {
  InlineSelect,
  InlineTextBoxField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import STATE_OPTIONS from 'app-ui-componentlibrary/dist/common/states';
import _ from 'lodash';
import {onlyAllowNumbers} from 'common/utils';

export class ApplicantInfo extends React.Component {
  constructor(props) {
    super(props);
    const applicantInfo = {
      applicantName: '',
    };
    this.state = {
      model: applicantInfo,
    };
  }

  componentDidMount() {
    if (!_.isEmpty(this.props.data)) {
      this.setState({model: this.props.data});
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.data, this.props.data)) {
      this.setState({model: this.props.data});
    }
  }

  saveApplicantInfo = (fieldName) => {
    const {saveEntityData, validationId} = this.props;
    const applicantInformation = this.state.model;

    saveEntityData(
      'data.payload.applicantInformation',
      'data',
      applicantInformation,
      validationId + '.' + fieldName
    );
  };

  render() {
    const {validationDirtyMap, validationErrors} = this.props;
    const findError = (field) => {
      const errs = _.get(_.get(validationErrors, 0), field);
      if (errs instanceof Array) {
        return _.find(errs, (err) => !err.isValid);
      }
      return errs;
    };
    const displayError = (field) => _.get(findError(field), 'isValid') === false;
    const errorMessage = (field) => _.get(findError(field), 'message');
    const isDirty = (field) => {
      const dirtyField = _.get(validationDirtyMap, ['dirty', field], false);
      return dirtyField || (_.get(validationDirtyMap, 'dirtyPage', false) && !dirtyField);
    };
    const handleChange = (name, value) => {
      let model = _.cloneDeep(this.state.model);
      _.set(model, name, value);
      this.setState({model});
    };
    const title = this.props.title || 'Applicant name (i.e., fire department name)';

    return (
      <Form>
        <p>
          Please provide the following additional information about the department or
          organization applying for this grant.
        </p>
        <InlineTextBoxField
          id="applicantName"
          title={title}
          label={title}
          name="applicantName"
          size="large"
          maxLength={101}
          value={_.get(this.state.model, 'applicantName')}
          handleChange={(e) => handleChange(e.target.name, e.target.value)}
          handleBlur={() => this.saveApplicantInfo('applicantName')}
          displayError={isDirty('applicantName') && displayError('applicantName')}
          errorMessages={errorMessage('applicantName')}
        />
        <br />
        <Header as="h4">Main address of location impacted by this grant</Header>
        <hr />
        <InlineTextBoxField
          id="mainAddress1"
          title="Main address 1"
          label="Main address 1"
          name="mainAddress.address1"
          size="large"
          value={_.get(this.state.model, 'mainAddress.address1')}
          maxLength={81}
          handleChange={(e) => handleChange(e.target.name, e.target.value)}
          handleBlur={() => this.saveApplicantInfo('address1')}
          displayError={isDirty('address1') && displayError('mainAddress.address1')}
          errorMessages={errorMessage('mainAddress.address1')}
        />
        <InlineTextBoxField
          id="mainAddress2"
          title="Main address 2"
          label="Main address 2"
          optional="true"
          size="large"
          name="mainAddress.address2"
          value={_.get(this.state.model, 'mainAddress.address2')}
          maxLength={81}
          handleChange={(e) => handleChange(e.target.name, e.target.value)}
          handleBlur={() => this.saveApplicantInfo('address2')}
          displayError={isDirty('address2') && displayError('mainAddress.address2')}
          errorMessages={errorMessage('mainAddress.address2')}
        />
        <Grid>
          <Grid.Column width={9}>
            <InlineTextBoxField
              id="City"
              title="City"
              label="City"
              name="mainAddress.city"
              width={10}
              value={_.get(this.state.model, 'mainAddress.city')}
              maxLength={81}
              handleChange={(e) => handleChange(e.target.name, e.target.value)}
              handleBlur={() => this.saveApplicantInfo('city')}
              displayError={isDirty('city') && displayError('mainAddress.city')}
              errorMessages={errorMessage('mainAddress.city')}
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <InlineSelect
              placeholder="State"
              id="State"
              label="State/territory"
              search
              selection
              title="State"
              name="mainAddress.state"
              value={_.get(this.state.model, 'mainAddress.state')}
              options={STATE_OPTIONS}
              handleChange={(e) => handleChange(e.target.name, e.target.value)}
              handleBlur={() => this.saveApplicantInfo('state')}
              displayError={isDirty('state') && displayError('mainAddress.state')}
              errorMessages={errorMessage('mainAddress.state')}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column width={5}>
            <InlineTextBoxField
              id="zipCode"
              title="Zip code"
              label="Zip code"
              name="mainAddress.zip"
              value={_.get(this.state.model, 'mainAddress.zip')}
              maxLength={6}
              handleChange={(e) =>
                handleChange(e.target.name, onlyAllowNumbers(e.target.value))
              }
              handleBlur={() => this.saveApplicantInfo('zip')}
              displayError={isDirty('zip') && displayError('mainAddress.zip')}
              errorMessages={errorMessage('mainAddress.zip')}
            />
          </Grid.Column>
          <Grid.Column width={3}>
            <InlineTextBoxField
              id="zipExtension"
              title="Zip extension"
              label="Zip extension"
              name="mainAddress.zipExtension"
              value={_.get(this.state.model, 'mainAddress.zipExtension')}
              maxLength={5}
              handleChange={(e) =>
                handleChange(e.target.name, onlyAllowNumbers(e.target.value))
              }
              handleBlur={() => this.saveApplicantInfo('zipExtension')}
              displayError={
                isDirty('zipExtension') && displayError('mainAddress.zipExtension')
              }
              errorMessages={errorMessage('mainAddress.zipExtension')}
            />
          </Grid.Column>
        </Grid>
        <InlineTextBoxField
          id="countryParish"
          title="In what county/parish is your organization physically located? If you have more than one station, in what county/parish is your main station located?"
          label="In what county/parish is your organization physically located? If you have more than one station, in what county/parish is your main station located?"
          name="mainAddress.county"
          value={_.get(this.state.model, 'mainAddress.county')}
          size="large"
          maxLength={101}
          handleChange={(e) => handleChange(e.target.name, e.target.value)}
          handleBlur={() => this.saveApplicantInfo('county')}
          displayError={isDirty('county') && displayError('mainAddress.county')}
          errorMessages={errorMessage('mainAddress.county')}
        />
      </Form>
    );
  }
}

export default connectDynamic(ApplicantInfo);
